import { css } from '@/styled-system/css';

const smoothTransition = {
  transition: 'all 0.15s ease-in-out',
};
const noUserSelect = {
  WebkitTouchCallout: 'none',
  userSelect: 'none' /* Chrome and Opera */,
  WebkitTapHighlightColor: 'transparent',
};

const textOverflow = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

const focusWithinStyles = {
  _focusWithin: {
    outlineWidth: '1px',
    outlineStyle: 'auto',
    outlineColor: 'hpxTeal600 !important',
    outlineOffset: '1px',
  },
  '& input:focus': {
    outlineWidth: '0',
    outlineStyle: 'none',
  },
};

const widthInputMdAndUp = '400px';
const widthInputXlAndUp = '720px';

export const autoCompleteContainerCx = () => {
  return {
    base: css({
      height: '100%',
      textAlign: 'left',
      md: {
        width: '450px',
      },
    }),
    full: css({
      width: 'auto',
      height: 'auto',
      paddingRight: '16px',
      md: {
        padding: 0,
        borderRightWidth: '1px',
        borderRightStyle: 'solid',
        borderRightColor: '#f2f2f2',
        height: '100%',
      },
    }),
    fullActive: css({
      borderWidth: '0',
      borderStyle: 'none',
      position: 'fixed',
      left: 0,
      height: '44px',
      md: {
        position: 'inherit',
        height: '100%',
      },
    }),
    homepage: css({
      position: 'relative',
      display: 'block',
      width: '100%',
      height: '40px',
      md: {
        height: '48px',
        width: '245px',
        minWidth: '245px',
      },
    }),
    srpFull: css({
      borderRightWidth: '0',
      borderRightStyle: 'none',
      padding: '0',
      paddingRight: '16px',
      width: '100%',
      md: {
        paddingRight: '0',
        width: '158px',
      },
      xxl: {
        width: '268px',
      },
    }),
  };
};

export const autoCompleteInputContainerCx = () => {
  return {
    base: css({
      position: 'relative',
      height: '100%',
      ...focusWithinStyles,
    }),

    full: css({
      position: 'relative',
      zIndex: 'zIndexLoader',
      width: '100%',
      height: '32px',
      marginRight: '16px',
      borderTopLeftRadius: '4px',
      borderTopRightRadius: '4px',
      borderBottomLeftRadius: '4px',
      borderBottomRightRadius: '4px',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: '#949494',
      ...focusWithinStyles,
      md: {
        borderTopLeftRadius: '0',
        borderTopRightRadius: '0',
        borderBottomLeftRadius: '0',
        borderBottomRightRadius: '0',
        height: '100%',
        margin: '0',
      },
    }),

    fullActive: css({
      position: 'relative',
      zIndex: 'zIndexLoader',
      width: '100%',
      minHeight: '44px',
      paddingTop: '0',
      paddingRight: '16px',
      paddingBottom: '0',
      paddingLeft: '16px',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: '#949494',
      borderTopLeftRadius: '0',
      borderTopRightRadius: '0',
      borderBottomLeftRadius: '0',
      borderBottomRightRadius: '0',
      backgroundColor: 'hpxWhite',
      ...focusWithinStyles,
      md: {
        maxWidth: '808px',
      },
    }),

    homepage: css({
      borderWidth: '0',
      borderStyle: 'none',
      marginLeft: '0',
      height: '40px',
      md: {
        height: '48px',
      },
    }),

    srpFull: css({
      marginRight: '0',
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: '#949494',
      borderTopLeftRadius: '2px',
      borderTopRightRadius: '2px',
      borderBottomLeftRadius: '2px',
      borderBottomRightRadius: '2px',
      ...focusWithinStyles,
    }),

    srpFullActive: css({
      position: 'relative',
      width: '100%',
      height: 'auto',
      marginBottom: '8px',
      ...focusWithinStyles,
      md: {
        width: '390px',
        marginLeft: '0',
      },
      xxl: {
        width: '720px',
        marginLeft: '8px',
      },
    }),
  };
};

export const searchIconCx = () => {
  return {
    base: css({
      width: '16px',
      height: '16px',
      position: 'relative',
      pointerEvents: 'none',
      top: '12px',
      left: '15px',
      zIndex: 'zIndexStep',
      md: {
        top: '14px',
        left: '18px',
      },
    }),

    full: css({
      top: '7px',
      left: '10px',
      md: {
        top: 'auto',
        left: '18px',
      },
    }),

    fullActive: css({
      top: '13px',
      left: '16px',
      md: {
        left: '56px',
      },
    }),

    srpFull: css({
      top: 'auto',
      md: {
        left: '8px',
      },
    }),

    srpFullActive: css({
      left: '0px',
      md: {
        left: '8px',
      },
    }),
  };
};

export const dropdownCx = () => {
  return {
    base: css({
      width: '100%',
      maxWidth: '100vw',
      backgroundColor: 'hpxWhite',
      zIndex: 'zIndexOverOverlay !important',
      maxHeight: '100vh',
      borderTopLeftRadius: '4px',
      borderTopRightRadius: '4px',
      borderBottomLeftRadius: '4px',
      borderBottomRightRadius: '4px',
      marginTop: '8px',
      md: {
        width: '450px',
        maxWidth: '808px',
        marginTop: '16px',
        maxHeight: 'none',
        overflowX: 'hidden',
        overflowY: 'auto',
      },
    }),

    full: css({
      position: 'absolute',
      width: '100vw',
      height: '100vh',
      top: '44px',
      left: '0',
      right: '0',
      maxHeight: '100vh',
      paddingTop: '0',
      paddingRight: '16px',
      paddingBottom: '16px',
      paddingLeft: '16px',
      borderTopLeftRadius: '0',
      borderTopRightRadius: '0',
      borderBottomLeftRadius: '0',
      borderBottomRightRadius: '0',
      marginTop: '0',
      md: {
        height: 'auto',
        maxHeight: '80vh',
        top: '0px',
        left: 'auto',
        right: 'auto',
      },
    }),

    homepage: css({
      position: 'absolute',
      top: '100%',
      left: '0',
      right: '0',
      zIndex: 'zIndexOverlay',
      padding: '0',
    }),

    srpFull: css({
      position: 'absolute',
      left: '0',
      top: '-20px',
      maxHeight: '100vh',
      paddingTop: '16px',
      overflowY: 'auto',
      overflowX: 'hidden',
      scrollbarGutter: 'stable both-edges',
      md: {
        marginTop: 0,
        maxWidth: '452px',
        width: '452px',
        paddingTop: '64px',
        left: '0',
      },
      xxl: {
        maxWidth: '880px',
        width: '880px',
      },
    }),
  };
};

export const sectionCx = () => {
  return {
    base: css({
      position: 'relative',
    }),

    full: css({
      md: {
        marginLeft: '0',
      },
    }),

    fullSrp: css({
      md: {
        width: widthInputMdAndUp,
        marginLeft: '0',
      },
      xxl: {
        width: 'auto',
        marginLeft: '8px',
      },
    }),

    notFirstOfTypeBefore: css({
      _before: {
        content: "''",
        position: 'absolute',
        left: '0',
        top: '0',
        height: '1px',
        width: '100%',
        maxWidth: widthInputXlAndUp,
        borderTopWidth: '1px',
        borderTopStyle: 'solid',
        borderTopColor: '#f2f2f2',
      },
    }),

    headerFull: css({
      md: {
        paddingTop: '16px',
      },
    }),
  };
};

export const inputCx = () => {
  return {
    base: css({
      height: '100%',
    }),

    full: css({
      paddingLeft: '0',
    }),

    fullActive: css({
      paddingLeft: '0px',
      md: {
        paddingLeft: '0px',
      },
    }),

    homepage: css({
      fontSize: 'sm',
      md: {
        fontSize: 'inherit',
      },
    }),

    srpFull: css({
      width: '100%',
    }),

    srpFullActive: css({
      marginLeft: '8px',
      md: {
        marginLeft: '16px',
      },
    }),

    dimmedText: css({
      color: 'hpxGrey600 !important',
    }),
  };
};

export const itemContainerCx = () => {
  return {
    base: css({
      ...smoothTransition,
      ...noUserSelect,
      ...textOverflow,
      display: 'flex',
      alignItems: 'center',
      height: '56px',
      maxWidth: widthInputXlAndUp,
      cursor: 'pointer',
      borderBottomWidth: '1px',
      borderBottomStyle: 'solid',
      borderBottomColor: '#f2f2f2',
      textAlign: 'left',
      color: 'hpxBlue600',
      paddingTop: '0',
      paddingRight: '16px',
      paddingBottom: '0',
      paddingLeft: '16px',
      '&:last-child': {
        borderBottomWidth: '0px',
        borderBottomStyle: 'none',
      },
      _focus: {
        outlineColor: 'hpxGrey600',
        outlineOffset: '1px',
        outlineStyle: 'auto',
        outlineWidth: '1px',
      },
      md: {
        height: '60px',
      },
    }),

    active: css({
      backgroundColor: 'hpxGrey100',
    }),

    itemFull: css({
      padding: '0',
      md: {
        paddingTop: '0',
        paddingRight: '8px',
        paddingBottom: '0',
        paddingLeft: '8px',
      },
    }),

    itemBorderTop: css({
      borderTopWidth: '1px',
      borderTopStyle: 'solid',
      borderTopColor: '#f2f2f2',
    }),
  };
};

export const itemIconContainerCX = css({
  display: 'flex',
  alignItems: 'center',
});

export const itemHeaderCx = () => {
  return {
    base: css({
      color: 'hpxGrey600',
      fontSize: 'sm',
      maxWidth: widthInputXlAndUp,
      paddingTop: '16px',
      paddingLeft: '16px',
    }),

    full: css({
      paddingLeft: '0',
      md: {
        paddingTop: '32px',
      },
    }),
  };
};

export const itemIconCX = css({
  color: 'hpxGrey600',
  width: '16px',
  minWidth: '16px',
  marginRight: '12px',
});

export const itemNoIconCX = css({
  width: '16px',
  minWidth: '16px',
});

export const itemTextCX = css({
  ...textOverflow,
  flexGrow: '1',
});

export const itemNameCX = css({
  ...textOverflow,
  display: 'block',
  maxWidth: 'calc(100vw - 44px)',
  md: {
    maxWidth: widthInputXlAndUp,
  },
});

export const itemDescriptionCX = css({
  ...textOverflow,
  display: 'block',
  fontSize: 'tiny',
  color: 'hpxGrey600',
  maxWidth: 'calc(100vw - 44px)',
  md: {
    maxWidth: widthInputXlAndUp,
  },
});

export const itemRecentCX = css({
  color: 'hpxGrey600',
});

export const itemRecentNumCX = css({
  color: 'hpxRed500',
  fontSize: 'tiny',
  paddingTop: '0',
  paddingRight: '0',
  paddingBottom: '8px',
  paddingLeft: '24px',
  md: {
    paddingTop: '0',
    paddingRight: '8px',
    paddingBottom: '8px',
    paddingLeft: '32px',
  },
});

export const itemMatchCX = css({
  fontWeight: 'bold',
});

export const helpContainerCX = css({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
  paddingTop: '48px',
  paddingRight: '0',
  paddingBottom: '48px',
  paddingLeft: '0',
  maxWidth: '100vw',
  cursor: 'default',
  textAlign: 'center',
  color: 'hpxGrey600',
  fontSize: 'md',
  borderBottomWidth: '1px',
  borderBottomStyle: 'solid',
  borderBottomColor: '#f2f2f2',
});

export const helpTermCX = css({
  color: 'hpxBlue600',
  fontWeight: 'bold',
});

export const helpDescriptionCX = css({
  paddingTop: '8px',
  fontSize: 'sm',
});

export const loginContainerCX = css({
  position: 'relative',
  padding: '26px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  _before: {
    content: '',
    position: 'absolute',
    left: '0',
    top: '0',
    height: '1px',
    width: '100%',
    maxWidth: widthInputXlAndUp,
    borderTopWidth: '1px',
    borderTopStyle: 'solid',
    borderTopColor: '#f2f2f2',
  },
});

export const loginTextCX = css({
  fontSize: 'sm',
  color: 'hpxGrey600',
  marginBottom: '16px',
});
